import { UserGroups } from "./../../assets/config/models";
import { Injectable } from "@angular/core";

import { map, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { SharedService } from "./sharedService";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { RegionService } from "../shared/services/region.service";

export type loginRequestBody = { username: string | null; password: string | null };

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private apiDomain: any;
  private Domain: any;
  private jwt: any;
  groupTypes = UserGroups;

  constructor(
    private http: HttpClient,
    private ss: SharedService,
    private router: Router,
    private regionService: RegionService,
  ) {
    this.apiDomain = ss.apiDomain;
    this.Domain = ss.Domain;
    this.jwt = localStorage.getItem("jwt");
  }

  login(credentials: loginRequestBody): Observable<any> {
    return this.http
      .post<any>(`${this.Domain}/jwt-pass-valet/`, credentials)
      .pipe(
        tap((result) => {
          console.log(result, "");
          localStorage.setItem(
            "user_details",
            JSON.stringify(result.user_details),
          );
          localStorage.setItem("jwt", result.token);
        }),
      );
  }

  ResetPassword(data: { email: any }): Observable<any> {
    return this.http
      .post<any>(`${this.apiDomain}customers/reset-password/`, data)
      .pipe(
        tap((result) => {
          console.log(result, "");
        }),
      );
  }

  changePassword(data: {
    old_password: string;
    new_password: string;
  }): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "JWT " + this.jwt,
    });

    return this.http
      .put<any>(`${this.apiDomain}customers/change-password/`, data, {
        headers,
      })
      .pipe(
        tap((result) => {
          console.log(result);
        }),
      );
  }

  createStaff(data: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "JWT " + this.jwt,
    });

    return this.http.post<any>(`${this.apiDomain}backend/create-user/`, data, {
      headers,
    });
  }

  makeStaff(data: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "JWT " + this.jwt,
    });

    return this.http
      .post<any>(`${this.apiDomain}backend/make-user-staff/`, data, { headers })
      .pipe(
        tap((result) => {
          console.log(result);
        }),
      );
  }

  editStaff(form: any, id: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "JWT " + this.jwt,
    });

    return this.http.put<any>(
      `${this.apiDomain}backend/create-user/${id}/`,
      form,
      { headers },
    );
  }

  editCompanyStaff(form: any, id: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "JWT " + this.jwt,
    });

    return this.http.put<any>(
      `${this.apiDomain}backend/account/account-staff/?account_id=${id}/`,
      form,
      { headers },
    );
  }

  navigateUser(userDetails: { group: any }) {
    const isPrivateUser = this.isPrivateUser(userDetails);
    const groupName = userDetails.group;
    console.log("Group name", groupName);
    if (isPrivateUser) {
      this.router.navigate(["/user/privateuser/"]);
    } else if (groupName == this.groupTypes.CHANNELPARTNER) {
      this.router.navigate(["/user/channel-dashboard/"]);
    } else if (groupName == this.groupTypes.ADMIN || this.groupTypes.MANAGER) {
      this.router.navigate(["/user/dashboard/"]);
    } else if (groupName == this.groupTypes.FINANCE) {
      this.router.navigate(["/user/financedashboard/"]);
    } else if (groupName == this.groupTypes.CORPORATE) {
      this.router.navigate(["/user/corporatedashboard/"]);
    }
  }

  isPrivateUser(userDetails: { group: UserGroups }) {
    return userDetails.group == this.groupTypes.PRIVATEMANAGER;
  }

  isPaymentMethodUser(userDetails: { account: { has_payment_source: any } }) {
    if (userDetails.account && userDetails.account.has_payment_source) {
      return true;
    }
    return false;
  }

  private extractData(res: any) {
    /* let body = res.json();
    console.log(body);
    return body || {}; */
    return res;
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    if (error.status == 400) {
      let body = error.json();
      return Promise.reject(body);
    }
    return Promise.reject(error.message || error);
  }
  private createAuthorizationHeader() {
    console.log("create authorization header");
    return new HttpHeaders({
      Authorization: "JWT " + localStorage.getItem("jwt"),
    });
  }

  createValletStaff(data: any): Observable<any> {
  return this.http.post<any>(
    `${this.apiDomain}pass-valet/create-valet-staff/`,
    data,
    {
      headers: this.createAuthorizationHeader(),
    }
  );
}

  isLoggedIn(): boolean {
    return !!localStorage.getItem("user_details");
  }

  logout(): void {
    localStorage.removeItem("user_details");
    localStorage.removeItem("jwt");
    this.regionService.clearRegion();
    this.jwt = null;
    this.router.navigate(["/auth/login"]);
  }
}
